import { observable, action, runInAction } from 'mobx'
import Api from '@api/xiu_yan/marketingToolsApi'
import indexStore from '../Tabs/store'
import { message, Modal } from 'hljd'
const confirm = Modal.confirm

class Store {
  @observable gift_content
  @observable gift_status
  @observable gift_reason

  @action
  getStatus = async () => {
    let { data } = await Api.record_list()
    runInAction(() => {
      this.gift_status = data[0].status
    })
  }

  @action
  getGift = async () => {
    let {
      data: { content, reason }
    } = await Api.current_list({ id: 1 })
    runInAction(() => {
      this.gift_content = content
      this.gift_reason = reason
    })
  }

  @action
  changeValue = e => {
    this.gift_content = e.target.value
    if (this.gift_content.length > 15) {
      this.gift_content = this.gift_content.substring(0, 15)
    }
  }

  @action
  saveGift = async () => {
    const { gift_content, gift_status } = this

    let patterns = /[^a-zA-Z0-9\u4E00-\u9FA5]/g

    if (!gift_content) {
      return message.warning('内容不能为空！')
    }

    if (patterns.test(gift_content)) {
      return message.warning('不可输入除中文，英文，数字外的其它符号！')
    }

    let params = {
      grade_privilege_id: 1,
      content: gift_content,
      status: 1
    }

    let apiName
    if (gift_status == 0) {
      apiName = Api.add(params)
    } else {
      apiName = Api.edit(params)
    }

    let { success } = await apiName
    if (success) {
      message.success('操作成功！')
      window.location.href = '#/localMerchant/marketingTools?key=1'
    }
  }

  @action
  closeArriveGift = () => {
    const { gift_content } = this
    let params = {
      grade_privilege_id: 1,
      content: gift_content,
      status: 0
    }

    confirm({
      title: '确定要关闭到店礼？',
      onOk: async () => {
        let { success } = await Api.edit(params)
        if (success) {
          message.success('操作成功！')
          indexStore.getTabInfo()
          indexStore.getGift(1)
        }
      }
    })
  }
}
export default new Store()
